module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inputLabel":"Search","noResultsText":"Your search didn\u0027t match any results."},"fi":{"inputLabel":"Haku","noResultsText":"Ei hakutuloksia."}}')
  delete Component.options._Ctor
}
